import React, { useState, useEffect } from "react";
import { Card, Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { ChargingBASE_URL } from "../../Config";

const TotalRecord = () => {
  const [userId, setUserId] = useState('');
  const [salesData, setSalesData] = useState(null);
  const [amountCountData, setAmountCountData] = useState(null);
  const [totalAgentData, setTotalAgentData] = useState(null);
  const [loading, setLoading] = useState(true); // Initially loading all data
  const [error, setError] = useState(null);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserId(user.userId);
    }
  }, []);

  // Function to fetch sales data
  const fetchSalesData = async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${ChargingBASE_URL}GetsalesCount?UserId=${userId}`);
      if (!response.ok) throw new Error("Failed to fetch sales data");
      const data = await response.json();
      setSalesData(data);
    } catch (error) {
      console.error("Sales data error:", error);
      setError("Error fetching sales data.");
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch amount count data
  const fetchAmountCountData = async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${ChargingBASE_URL}GetAmountCount?UserId=${userId}`);
      if (!response.ok) throw new Error("Failed to fetch amount count data");
      const data = await response.json();
      setAmountCountData(data);
    } catch (error) {
      console.error("Amount count error:", error);
      setError("Error fetching amount count data.");
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch total agent data
  const fetchTotalAgent = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${ChargingBASE_URL}GetTotalAgent`);
      if (!response.ok) throw new Error("Failed to fetch total agent data");
      const data = await response.json();
      setTotalAgentData(data);
    } catch (error) {
      console.error("Agent data error:", error);
      setError("Error fetching total agent data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchSalesData();
      fetchAmountCountData();
      fetchTotalAgent();
    }
  }, [userId]);

  // Helper function to display data or spinner
  const renderValue = (value) => {
    return loading ? <Spinner animation="border" size="sm" /> : (value ?? "No Data");
  };

  return (
    <Container className="py-5">
      {error && <Alert variant="danger" className="text-center">{error}</Alert>}

      <Row xs={1} md={2} lg={3} className="g-4">
        {/* Sales Data Cards */}
        <Col>
          <Card className="text-white bg-success h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Subscriptions</Card.Title>
              <Card.Text className="display-4">
                {renderValue(salesData?.currentDayRevenue)}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-danger h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Reversal</Card.Title>
              <Card.Text className="display-4">
                {renderValue(salesData?.currentTotlalReversed)}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-secondary h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Failed Subscriptions</Card.Title>
              <Card.Text className="display-4">
                {renderValue(salesData?.failed)}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Total Agent Data Card */}
       

        {/* Amount Count Cards */}
        <Col>
          <Card className="text-white bg-success h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Revenue (PKR)</Card.Title>
              <Card.Text className="display-4">
                {renderValue(amountCountData?.revenue)}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-danger h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Reversed (PKR)</Card.Title>
              <Card.Text className="display-4">
                {renderValue(amountCountData?.totlalReversedAmount)}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-primary h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Total Agent</Card.Title>
              <Card.Text className="display-4">
                {renderValue(totalAgentData?.totalAgents)}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TotalRecord;
